var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{class:{ circleImage:true, grayed: _vm.disabled },style:(_vm.showBackground ? { 'background-color': _vm.stringToColour(_vm.name) } : {}),attrs:{"src":_vm.image ? _vm.image : '/images/avatars/agent.png',"onerror":"this.src='/images/avatars/agent.png'"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }